import React from "react";
import HomePage from "@/components/pages/HomePage";
import getServer from "@/utils/functions/function";

export default function Home({ data, RoutingController }) {
  return <HomePage data={data} RoutingController={RoutingController} />;
}

export async function getServerSideProps(context) {
  return await getServer(context);
}

